import type { KeyConfig, Panel } from './models.js';

export type TargetKind = 'ch' | 'user';

export interface ParsedTarget {
  kind: TargetKind;
  id: string;
}

export const chTarget = (channelId: string): string => `ch:${channelId}`;
export const userTarget = (userId: string): string => `user:${userId}`;

export function parseTarget(target: string): ParsedTarget | null {
  const idx = target.indexOf(':');
  if (idx <= 0) return null;
  const kind = target.slice(0, idx);
  const id = target.slice(idx + 1);
  if ((kind !== 'ch' && kind !== 'user') || !id) return null;
  return { kind, id };
}

/** Targets a panel permits for talking / listening. */
export function allowedTargets(panel: Panel | null | undefined, mode: 'talk' | 'listen'): Set<string> {
  const out = new Set<string>();
  if (!panel) return out;
  for (const key of panel.keys) {
    const ok = mode === 'talk' ? key.talk !== 'none' : key.listen !== 'none';
    if (!ok) continue;
    for (const t of key.targets) out.add(t);
  }
  return out;
}

/** Keys whose targets include `target`. */
export function keysForTarget(panel: Panel | null | undefined, target: string): KeyConfig[] {
  if (!panel) return [];
  return panel.keys.filter((k) => k.targets.includes(target));
}

export function intersect(a: Iterable<string>, b: Set<string>): string[] {
  const out: string[] = [];
  for (const x of a) if (b.has(x)) out.push(x);
  return out;
}

export function sameStringSet(a: string[], b: string[]): boolean {
  if (a.length !== b.length) return false;
  const s = new Set(a);
  for (const x of b) if (!s.has(x)) return false;
  return true;
}
